import { InfraAppModel } from "@api/types/infraapp";
import { httpClient } from "../../httpClient";

type Data = any;

const infraAppWebApi = "/api/v1/infrastructure-applications/";

export async function get(): Promise<any> {
  try {
    const { data } = await httpClient.get(infraAppWebApi);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

function checkApproverDistroAndInfra(payload: any) {
  let approverDistro = null;
  let infrastructure = null;
  if (payload.approverDistro) {
    approverDistro = {
      id: payload.approverDistro,
      name: null,
    };
  }

  if (payload.infrastructure) {
    infrastructure = {
      id: payload.infrastructure,
      name: null,
    };
  }

  return { approverDistro, infrastructure };
}

export async function post(payload: InfraAppModel): Promise<any> {
  try {
    const approverDistroInfraValue = checkApproverDistroAndInfra(payload);
    payload.approverDistro = approverDistroInfraValue.approverDistro;
    payload.infrastructure = approverDistroInfraValue.infrastructure;
    const { data } = await httpClient.post<Data>(infraAppWebApi, payload);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function put(id: number, payload: InfraAppModel): Promise<any> {
  try {
    const approverDistroInfraValue = checkApproverDistroAndInfra(payload);
    payload.approverDistro = approverDistroInfraValue.approverDistro;
    payload.infrastructure = approverDistroInfraValue.infrastructure;
    const { data } = await httpClient.put<Data>(
      `${infraAppWebApi}${id}`,
      payload
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export const infraapp = {
  get,
  post,
  put,
};
